/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../models/meevo.dtos.d.ts" />

module Meevo.Components.PassiveAlert {
    "use strict";

    export class PassiveAlert implements angular.IDirective {
        restrict = 'AE';
        scope = {
            entity1Id: "@entity1Id",
            entity2Id: "@entity2Id",
            alerts: "=",
            alertsCount: "@",
            ngClick: "&?",
            specialText: "@?",
            customAlertClick: "&?",
            customAlertIconId: "@?",
            meevoAlert: "@meevoAlert",
            peekAlert: '=?',
            client: '=?',
            dashboardElement: "=?",
            hasAlert: "&?",
            hideCount: "=?"
        };
        templateUrl = "app/components/controls/passiveAlert/passiveAlert.template.html";

        constructor(
            private restServer,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected $translate: angular.translate.ITranslateService,
            protected $filter: angular.IFilterService,
            protected $q: angular.IQService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private membershipDetailsService,
            private appSettings: Meevo.Components.Common.IAppSettings) {
        }

        static factory(): angular.IDirectiveFactory {
            let directive = (
                restServer,
                dataService,
                $translate,
                $filter,
                $q,
                securityService,
                membershipDetailsService,
                appSettings
            ) => new PassiveAlert(
                restServer,
                dataService,
                $translate,
                $filter,
                $q,
                securityService,
                membershipDetailsService,
                appSettings
            );

            directive.$inject = [
                'restServer',
                'meevo.components.common.DataService',
                '$translate',
                '$filter',
                '$q',
                'meevo.components.common.SecurityService',
                'meevo.components.common.MembershipDetailsService',
                'meevo.AppSettings'
            ];

            return directive;
        }

        link = (scope, element, attrs) => {
            //set scope.alerts to an isolated variable inside passive alerts
            scope.currentClientAlerts = scope.alerts;
            scope.membershipDetailsService = this.membershipDetailsService;
            let alertIcon = element.find(".alertIcon");
            let alertItems = element.find(".alertItems");
            let meevoAlert = attrs.meevoAlert.toLowerCase();
            let getAlerts = undefined;
            let filterMeevoCurrency = this.$filter('meevoCurrency') as any;
            let filterNumber = this.$filter('number') as any;
            if (_.isUndefined(scope.dashboardElement)) scope.dashboardElement = false;

            //set watch on alerts array. 
            //if it is undefined or has no length then reset the variable used in side passive alerts
            scope.$watch("alerts", resetAlertParams);
            function resetAlertParams() {
                if (_.isUndefined(scope.alerts)) return;
                if ( scope.alerts.length == 0) {
                    scope.currentClientAlerts = undefined;

                }
            }

            let alertIconHandler = () => {
                if (scope.ngClick != undefined) {
                    return;
                }

                $('.alertItems').not(alertItems).hide();

                if (!alertItems.is(":hidden")) {
                    hide();
                    return;
                }

                if (getAlerts) {
                    getAlerts();
                }

                show();
            }

            if (scope.customAlertIconId) {
                alertIcon.remove();
                alertIcon = element.parent().find(`#${scope.customAlertIconId}`);
                alertIcon.on("click", alertIconHandler);
            } else {
                element.on("click", '.alertIcon', alertIconHandler);
            }

            var clickHandler = e => {
                if (!alertIcon.is(e.target)) // if the target of the click isn't the icon
                {
                    hide();
                }
            }

            //hide/show for toggling of notification drop down
            function hide() {
                alertItems.hide();
                $(document).off("click", clickHandler);
            }


            function show() {
                alertItems.show();
                $(document).on("click", clickHandler);
            }

            switch (meevoAlert) {
                case "client":
                case "membershipalerts":
                case "clientpointsalerts":
                case "giftcardalerts":
                case "packagealerts":
                case "clientaccountalerts":
                case "cancelnoshow":
                case "minor":
                case "clienttype":
                    //watch used in appt book. pre-initializes notifications
                    scope.$watch("entity1Id", handleEntityChange);
                    break;
                case "clientnote":
                    scope.$watch("entity1Id", handleEntityChange);
                    scope.$watch("alerts", processClientNotes, true);
                    break;
                case "service":
                    scope.$watch("entity1Id", handleEntityChange);
                    scope.$watch("entity2Id", handleEntityChange);
                    break;

                case "alerts":
                    //send the changed alert param directly to the response handler
                    scope.$watch("alerts", handleRestResponse, true);
                    break;

                case "servicenote":
                    getAlerts = () => {
                        if (scope.currentClientAlerts) {
                            return;
                        }

                        let request: any = {
                            pageNumber: 0,
                            itemsPerPage: 25,
                            sortDirection: Meevo.Model.SortDirection.Descending,
                            criteria: {
                                filter: ''
                            }
                        }

                        this.dataService.getListPaged("service", request, scope.entity1Id, "Notes").then((response: any) => {
                            scope.currentClientAlerts = [];
                            for (let note of response) {
                                scope.currentClientAlerts.push({
                                    alertMessage: note.noteText,
                                    alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
                                });
                            }
                            raiseHasAlert();
                        });
                    }
                    break;

                default:
                    throw "Alert context unknown";
            }

            let $this = this;

            //reset for notes
            function resetAlerts() {
                scope.alertsCount = 0;
            }

            function clientAlert() {
                if (!scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.restServer.getClientAlerts(scope.entity1Id, handleRestResponse);
            }

            function serviceAlert() {
                if (!scope.entity1Id || scope.entity1Id.length === 0 ||
                    !scope.entity2Id || scope.entity2Id.length === 0) {
                    return;
                }

                $this.restServer.getServiceAlerts(scope.entity1Id, scope.entity2Id, handleRestResponse);
            }

            function clientNoteAlert() {
                resetAlerts();

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                let request: any = {
                    criteria: {
                        filter: ''
                    }
                }

                $this.dataService.getCount("client", request, scope.entity1Id, "Notes").then(
                    (response: any) => {
                        scope.alertsCount = response;
                        if (response > 0) {
                            raiseHasAlert();
                        }
                    });

                getAlerts = () => {
                    // called when alert is clicked
                    if (scope.currentClientAlerts) {
                        return;
                    }

                    let request: any = {
                        pageNumber: 0,
                        itemsPerPage: 1,
                        sortDirection: Meevo.Model.SortDirection.Descending,
                        criteria: {
                            filter: ''
                        }
                    }

                    $this.dataService.getListPaged("client", request, scope.entity1Id, "Notes")
                        .then((response: any) => {
                            processClientNotes(response);
                        });
                }
            }

            function membershipAlerts() {

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.dataService.getItem("Membership/Client", scope.entity1Id, "").then((response: any) => {
                    scope.currentClientAlerts = [];

                    scope.currentClientAlerts.push({
                        alertMessage: response.membershipDisplayName,
                        alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                        alertClick: scope.customAlertClick,
                    });
                    raiseHasAlert();
                });
            }

            function minorAlert() {
                resetAlerts();

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.dataService.getItem("Client", scope.entity1Id, "").then((response: any) => {
                    scope.currentClientAlerts = [];

                    if (!response.isMinor) {
                        return;
                    }

                    scope.currentClientAlerts.push({
                        alertMessage: $this.$translate.instant('LABEL_MINOR'),
                        alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
                    });
                    raiseHasAlert();
                });
            }

            function clientTypeAlert() {
                resetAlerts();

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.dataService.customMethodData(`/api/client/${scope.entity1Id}/clienttypes`, "get", null).then(response => {
                    scope.currentClientAlerts = [];

                    if (!response.data || response.data.length < 1) {
                        return;
                    }

                    $this.dataService.getItem("clientClientType", response.data[0].id).then((results: any) => {
                        scope.currentClientAlerts.push({
                            alertMessage: results.displayName,
                            alertPriorityLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                            alertColor: results.color
                        });

                        raiseHasAlert();
                    })
                });
            }

            function clientPointAlerts() {

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                var thisEntity1Id = scope.entity1Id;
                $this.dataService.customMethodData(`api/ClientPoint/${thisEntity1Id}?includeClosestExpiring=false`, "get", {}).then((response: any) => {
                    scope.currentClientAlerts = [];

                    if (response.data.remainingPoints >= 1) {
                        let remainingPoints = filterNumber(response.data.remainingPoints);
                        let remainingAmount = filterMeevoCurrency(response.data.remainingAmount);

                        scope.currentClientAlerts.push({
                            totalPoints: remainingPoints,
                            totalValue: remainingAmount,
                            alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                            alertClick: scope.customAlertClick
                        });
                        raiseHasAlert();

                        scope.clientHomeLocationId = response.data.clientHomeLocationId;
                        scope.clientHomeLocationName = response.data.clientHomeLocationName;
                    }

                });
            }

            function giftCardAlerts() {
                var currentClientAlertsCount = 0;
                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_USEEXPIREDGIFTCARD).then(result => {
                    let request : any = {
                        criteria: {
                            ClientIds: [scope.entity1Id]
                        }
                    };
                    if (result !== Meevo.Model.SecurityAccessEnum.Grant) {
                        request.criteria.IncludeExpired = false;
                    }
                    //if preferences set to restrict GC from other locations, filter by current location only
                    request.criteria.isGlobal = !$this.appSettings["APP_BUSINFOSETTINGS"].registerSettings.restrictGiftCardViewingRedemption;
                    $this.dataService.customMethodData('/api/ClientGiftCard/Count/', "POST", request).then((response: any) => {
                        scope.currentClientAlerts = [];
                        currentClientAlertsCount = +response.data;

                        let giftCardText = $this.$translate.instant('LABEL_GIFT_CARD');

                        for (var i = 0; i < currentClientAlertsCount; i++) {
                            scope.currentClientAlerts.push({
                                alertMessage: `${giftCardText} ${i + 1}`,
                                alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
                            });
                        }
                        raiseHasAlert();
                    });
                });
            }

            function cancelNoShowAlerts() {

                if (!$this.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings
                    || !$this.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings.cancelNoShowIndicator) {
                    return;
                }

                resetAlerts();

                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                let request = {
                    clientId: scope.entity1Id
                }

                $this.dataService.customMethodData('/api/CancelNoShowAppointmentServiceIndicator/Count/', "POST", request).then((response: any) => {
                    scope.alertsCount = +response.data;
                    scope.currentClientAlerts = [];

                    const alertMessage = `${$this.$translate.instant('LABEL_CANCELLED_OR_NOSHOW')}: ${scope.alertsCount}`;

                    for (var i = 0; i < scope.alertsCount; i++)
                    {
                        scope.currentClientAlerts.push({
                            alertMessage
                        });
                    }
                    raiseHasAlert();
                })
            }

            function packageAlerts() {
                var currentClientAlertsCount = 0;
                var unlimitedPackagesCount = 0;
                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                let promises = [
                    $this.securityService.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_REDEEMEXPIREDPACKAGE),
                    $this.dataService.customMethodData("api/Tenant/BusinessInfo/Settings", "get", null),
                ];

                $this.$q.all(promises).then((response: any) => {
                    let securityResult = response[0];
                    let settings = response[1].data.registerSettings;

                    let clientGlobalId = scope.entity1Id;
                    let request = {
                        criteria: {
                            RedeemedExpiredPackage: securityResult === Meevo.Model.SecurityAccessEnum.Grant,
                            allowExpiredPackagesForRedemptionAtAnyLocation: settings.allowExpiredPackagesForRedemptionAtAnyLocation,
                            allowCustomPackagesFromAnyLocation: settings.allowCustomPackageRedemptionAtAnyLocation
                        },
                    };

                    $this.dataService.customMethodData(`/api/Client/${clientGlobalId}/AvailablePackage/Count`, "POST", request).then((response: any) => {
                        scope.currentClientAlerts = [];
                        currentClientAlertsCount = +response.data.allPackagesCount;
                        unlimitedPackagesCount = +response.data.unlimitedPackagesCount;

                        let packageText = $this.$translate.instant('LABEL_PACKAGE');

                        for (let i = 0; i < currentClientAlertsCount; i++) {
                            scope.currentClientAlerts.push({
                                alertMessage: `${packageText} ${i + 1}`,
                                alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                                unlimitedPackagesCount
                            });
                        }
                        raiseHasAlert();
                    });
                });
            }


            function clientAccountAlerts() {
                var currentClientAlertsCount = 0;


                if (scope.currentClientAlerts || !scope.entity1Id || scope.entity1Id.length === 0) {
                    return;
                }

                $this.dataService.getItem("client", new Guid(scope.entity1Id), "accountbalance").then((response: any) => {
                    scope.currentClientAlerts = [];
                    scope.accountBalance = +response.accountBalance;
                    currentClientAlertsCount = scope.accountBalance !== 0 ? 1 : 0;


                    if (currentClientAlertsCount > 0) {

                        let accountBalance = filterMeevoCurrency(response.accountBalance);

                        scope.currentClientAlerts.push({
                            alertMessage: `${accountBalance}`,
                            alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal,
                            alertClick: scope.customAlertClick,
                        });
                        raiseHasAlert();
                    }
                });
            }

            function handleEntityChange() {
                //handles calling of specific alert type
                scope.currentClientAlerts = undefined;

                switch (meevoAlert) {
                    case "client":
                        clientAlert();
                        break;

                    case "service":
                        serviceAlert();
                        break;

                    case "clientnote":
                        clientNoteAlert();
                        break;

                    case "membershipalerts":
                        membershipAlerts();
                        break;

                    case "clientpointsalerts":
                        clientPointAlerts();
                        break;

                    case "giftcardalerts":
                        giftCardAlerts();
                        break;

                    case "packagealerts":
                        packageAlerts();
                        break;
                    case "cancelnoshow":
                        cancelNoShowAlerts();
                        break;
                    case "clientaccountalerts":
                        clientAccountAlerts();
                        break;
                    case "minor":
                        minorAlert();
                        break;
                    case "clienttype":
                        clientTypeAlert();
                        break;
                }
            }

            function handleRestResponse(response) {
                if (!_.isEmpty(response)) {
                    scope.currentClientAlerts = response;
                    raiseHasAlert();
                }
            }

            function processClientNotes(notes) {
                scope.currentClientAlerts = [];
                if (!notes) {
                    scope.alertsCount = 0;
                    return;
                }
                scope.alertsCount = notes.length;
                if (notes.length > 0) {
                    scope.currentClientAlerts.push({
                        alertMessage: notes[0].noteText,
                        alertPriortyLevel: Meevo.Model.AlertPriorityLevelEnum.Normal
                    });
                }               
                raiseHasAlert();
            }

            function raiseHasAlert() {
                if ((scope.alertsCount > 0 || (scope.currentClientAlerts && scope.currentClientAlerts.length)) && scope.hasAlert) {
                    scope.hasAlert({ isGeneralAlert: meevoAlert === "alerts" });
                }
            }

            scope.getAlertItemClass = alertItem => {

                //sets the alert css class
                var className;
                switch (meevoAlert) {
                    case "clientnote":
                    case "servicenote":
                        className = "note";
                        break;

                    case "membershipalerts":
                        className = "membership";
                        break;

                    case "clientaccountalerts":
                        className = "clientaccount";
                        break;
                    case "cancelnoshow":
                        className = "cancelNoShowAlert";
                        break;
                    default:
                        //assigns the priority class off alert
                        className = 'normal';
                        switch (alertItem.alertPriorityLevel) {
                            case Meevo.Model.AlertPriorityLevelEnum.High:
                                className = 'high';
                                break;
                            case Meevo.Model.AlertPriorityLevelEnum.Good:
                                className = 'good';
                                break;
                        }
                        break;
                }
                return className;
            }

            scope.getFillColor = (currentClientAlert) => {
                if (!currentClientAlert) {
                    return;
                }

                return {
                    'fill': currentClientAlert.alertColor ? currentClientAlert.alertColor : 'black'
                };
            }

            scope.getAlertIconText = (alerts) => {
                //sets text of alert
                switch (meevoAlert) {
                    case "clientpointsalerts":
                    case "giftcardalerts":
                    case "packagealerts":
                    case "clientaccountalerts":
                    case "cancelnoshow":
                    case "minor":
                    case "clienttype":
                        return null;
                    case "clientnote":
                    case "servicenote":
                    default:
                        return scope.alertsCount || (alerts ? alerts.length : null);
                }
            }

            scope.getAlertIconClass = (alerts) => {
                //sets icon class
                let className = '';
                switch (meevoAlert) {
                    case "clientnote":
                        className = "note";
                        break;
                    case "servicenote":
                        className = "service-note";
                        break;
                    case "clientpointsalerts":
                        className = "clientpoints";
                        break;
                    case "giftcardalerts":
                        className = "giftcard";
                        break;
                    case "packagealerts":
                        className = alerts &&
                            alerts.length > 0 &&
                            alerts[0].unlimitedPackagesCount &&
                            alerts[0].unlimitedPackagesCount > 0 ?
                            "unlimitedPackage" :
                            "package";
                        break;
                    case "clientaccountalerts":
                        className = scope.accountBalance > 0 ? "clientaccountpositive" : "clientaccountnegative";
                        break;
                    case "cancelnoshow":
                        className = "cancelNoShowAlert";
                        break;
                    case "minor":
                        className = "minorAlert";
                        break;
                    case "clienttype":
                        className = "clientTypeAlert";
                        break;
                    default:
                        if (alerts && alerts.length > 0) {
                            let nonNormalAlerts = _.filter(alerts, (alert: any) =>
                                alert.alertPriorityLevel === Meevo.Model.AlertPriorityLevelEnum.High ||
                                alert.alertPriorityLevel === Meevo.Model.AlertPriorityLevelEnum.Good);

                            // Color of icon should be for high or good first and fallback to normal
                            let priorityLevel = nonNormalAlerts.length > 0
                                ? nonNormalAlerts[0].alertPriorityLevel
                                : Meevo.Model.AlertPriorityLevelEnum.Normal;

                            switch (priorityLevel) {
                                case Meevo.Model.AlertPriorityLevelEnum.High:
                                    className = 'high';
                                    break;
                                case Meevo.Model.AlertPriorityLevelEnum.Normal:
                                    className = 'normal';
                                    break;
                                case Meevo.Model.AlertPriorityLevelEnum.Good:
                                    className = 'good';
                                    break;
                            }

                        }
                        break;
                }
                return className;
            }

            scope.getAlertIconTitle = (alerts) => {
                let titleText = '';
                switch (meevoAlert) {
                    case "packagealerts":
                        titleText = alerts && alerts.length > 0 && alerts[0].unlimitedPackagesCount && alerts[0].unlimitedPackagesCount > 0 ?
                            $this.$translate.instant('LABEL_PASSIVE_ALERTS_PACKAGES_INCLUDING_UNLIMITED',
                                { value: alerts[0].unlimitedPackagesCount }) :
                            $this.$translate.instant('LABEL_PASSIVE_ALERTS_PACKAGES');
                        return titleText;
                    case "servicenote":
                        titleText = $this.$translate.instant(alerts && alerts.length === 1 ? 'LABEL_NOTE' : 'LABEL_NOTES');
                        return titleText;
                    case "clientnote":
                        titleText = $this.$translate.instant(alerts && alerts.length === 1 ? 'LABEL_NOTE' : 'LABEL_NOTES');
                        return titleText;
                    case "clientpointsalerts":
                        titleText = $this.$translate.instant('LABEL_POINTS');
                        return titleText;
                    case "cancelnoshow":
                        const text = !!scope.alertsCount && scope.alertsCount > 1 ? 'LABEL_CANCEL_NOSHOWS' : 'LABEL_CANCEL_NOSHOW';
                        titleText = $this.$translate.instant(text);
                        return titleText;
                    case "giftcardalerts":
                        titleText = $this.$translate.instant((scope.currentClientAlerts && scope.currentClientAlerts.length > 1) ?
                            'LABEL_GIFT_CARDS' : 'LABEL_GIFT_CARD');
                        return titleText;
                    case "minor":
                        return $this.$translate.instant('LABEL_MINOR');
                    case "clienttype":
                        return scope.currentClientAlerts && scope.currentClientAlerts.length > 0 ? scope.currentClientAlerts[0].alertMessage : '';
                    default:
                        titleText = $this.$translate.instant('LABEL_ALERTS');
                        return titleText;
                }
            }

            scope.getAlertMessageStyle = (alerts) => {
                switch (meevoAlert) {
                    case "clientaccountalerts":
                        return {
                            color: scope.accountBalance > 0 ? 'green' : scope.accountBalance < 0 ? 'red' : 'black'

                        };
                    default:
                        return null;
                }
            }

            scope.getPeekStyle = (alerts) => {

                switch (meevoAlert) {
                    case "clientpointsalerts":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': '#ffa502' };
                        return;
                    case "giftcardalerts":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': '#00b101' };
                    case "packagealerts":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': '#0196ff' };
                    case "clientaccountalerts":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': scope.accountBalance > 0 ? '#32d306' : scope.accountBalance < 0 ? '#f01206' : 'black' };
                    case "cancelnoshow":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': '#FF0000' };
                    case "alerts":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': '#f59160' };
                    case "clienttype":
                        if (!_.isUndefined(scope.currentClientAlerts) && scope.currentClientAlerts.length > 0) return { 'background-color': scope.currentClientAlerts[0].alertColor ? scope.currentClientAlerts[0].alertColor : 'black' }
                    default:
                        return null;
                }

            }

            scope.getSecondaryPeekStyle = (alerts) => {
                switch (meevoAlert) {
                    case "someCase":
                        return { 'background-color': '#000' };
                    default:
                        return scope.getPeekStyle(alerts);
                }
            }

            scope.getMeevoAlert = () => {
                return meevoAlert;
            }
        }
    }

    angular.module("meevo.components.controls").directive('meevoAlert', PassiveAlert.factory());
}